export default __webpack_public_path__ + "static/media/description-icon.db267c24.svg";